export const aboutData = {
  brandStory: {
    title: "让每一部好漫画被看见",
    content: [
      "51漫画创立于2018年，是国内最早专注于免费漫画阅读的在线平台之一。我们的初心很简单：让每一个热爱漫画的人，都能零门槛地享受阅读的乐趣。",
      "从最初仅有数百部作品的小型站点，发展到如今汇聚超过6000部漫画、日活跃用户超过200万的行业标杆，51漫画始终坚持'免费阅读、正版授权、优质体验'三大核心原则。我们相信，好的故事值得被更多人看到，不应该被付费门槛阻挡。",
    ],
    image: "https://readdy.ai/api/search-image?query=Modern%20creative%20workspace%20with%20comic%20artists%20drawing%20at%20digital%20tablets%2C%20multiple%20monitors%20displaying%20manga%20pages%2C%20warm%20studio%20lighting%2C%20inspirational%20creative%20atmosphere%2C%20digital%20art%20style%2C%20clean%20professional%20composition&width=1200&height=800&seq=about-brand-01&orientation=landscape",
  },
  mission: {
    title: "连接创作者与读者",
    items: [
      {
        icon: "ri-book-open-line",
        title: "海量正版资源",
        description: "汇聚超过6000部正版授权漫画，涵盖热血、恋爱、悬疑、搞笑、科幻、仙侠等全品类题材。",
      },
      {
        icon: "ri-download-cloud-line",
        title: "免费畅读体验",
        description: "坚持免费阅读理念，无需付费订阅即可畅享海量漫画内容，支持在线观看与离线下载。",
      },
      {
        icon: "ri-user-star-line",
        title: "作者扶持计划",
        description: "为原创漫画作者提供创作资金、编辑指导、流量推广等全方位支持，助力优秀作品成长。",
      },
      {
        icon: "ri-community-line",
        title: "活跃读者社区",
        description: "打造活跃的漫画爱好者社区，支持评论互动、书单分享、同人创作等多元化交流。",
      },
    ],
  },
  stats: [
    { label: "漫画作品", value: "6,000+", icon: "ri-book-2-line" },
    { label: "日活用户", value: "200万+", icon: "ri-user-3-line" },
    { label: "总阅读量", value: "50亿+", icon: "ri-eye-line" },
    { label: "签约作者", value: "1,200+", icon: "ri-pen-nib-line" },
    { label: "日均更新", value: "500+", icon: "ri-refresh-line" },
    { label: "成立年份", value: "2018", icon: "ri-calendar-line" },
  ],
  testimonials: [
    {
      name: "小林漫画迷",
      avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20male%20anime%20style%20portrait%20with%20warm%20smile%2C%20casual%20outfit%2C%20clean%20soft%20background%2C%20digital%20art%20style%2C%20friendly%20and%20approachable%20character%20design&width=200&height=200&seq=avatar-01&orientation=squarish",
      role: "漫画爱好者",
      content: "51漫画是我用过最好的漫画平台！完全免费不说，更新速度还特别快。我最喜欢追《斗破苍穹》和《魔道祖师》，每天睡前必看！",
    },
    {
      name: "二次元少女",
      avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20female%20anime%20style%20portrait%20with%20long%20hair%20and%20gentle%20expression%2C%20pastel%20colors%2C%20clean%20soft%20background%2C%20digital%20art%20style%2C%20cute%20and%20warm%20character%20design&width=200&height=200&seq=avatar-02&orientation=squarish",
      role: "大学生读者",
      content: "作为一个学生党，免费追漫真的太重要了。51漫画的APP界面很清爽，夜间模式也很护眼。强烈推荐给所有漫画爱好者！",
    },
    {
      name: "漫画创作者阿华",
      avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20male%20anime%20style%20portrait%20with%20glasses%20and%20creative%20expression%2C%20holding%20drawing%20pen%2C%20clean%20warm%20background%2C%20digital%20art%20style%2C%20artistic%20and%20passionate%20character%20design&width=200&height=200&seq=avatar-03&orientation=squarish",
      role: "签约漫画家",
      content: "在51漫画平台连载两年多了，编辑团队非常专业，读者社区也很活跃。我的作品从零到百万阅读量，离不开平台的全力支持。",
    },
    {
      name: "国漫铁粉老张",
      avatar: "https://readdy.ai/api/search-image?query=Middle-aged%20Asian%20male%20anime%20style%20portrait%20with%20kind%20expression%2C%20casual%20outfit%2C%20clean%20neutral%20background%2C%20digital%20art%20style%2C%20reliable%20and%20enthusiastic%20character%20design&width=200&height=200&seq=avatar-04&orientation=squarish",
      role: "资深漫迷",
      content: "看了二十多年漫画，51漫画让我重新找回了追更的激情。平台推荐的漫画质量都很高，社区氛围也很好，没有乱七八糟的广告。",
    },
  ],
  team: [
    {
      name: "张明远",
      role: "创始人兼CEO",
      image: "https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20executive%20portrait%20in%20modern%20office%20setting%2C%20confident%20smile%2C%20business%20casual%20attire%2C%20warm%20natural%20lighting%2C%20clean%20background%2C%20digital%20art%20style&width=400&height=400&seq=team-01&orientation=squarish",
      quote: "我们的目标很简单：让每一位漫画爱好者都能免费、便捷地读到最好的漫画。",
    },
    {
      name: "李雪琪",
      role: "内容总监",
      image: "https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20executive%20portrait%20in%20creative%20office%20setting%2C%20warm%20and%20approachable%20smile%2C%20stylish%20attire%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20digital%20art%20style&width=400&height=400&seq=team-02&orientation=squarish",
      quote: "每一部好作品都值得被看见。我们做的，就是为这些作品搭建通往读者的桥梁。",
    },
  ],
  contact: {
    email: "contact@51manhua.com",
    businessEmail: "bd@51manhua.com",
    address: "北京市海淀区中关村科技园51漫画大厦8层",
    phone: "400-888-5151",
    workHours: "周一至周五 9:00-18:00",
  },
  cooperation: {
    title: "商务合作",
    items: [
      {
        title: "版权合作",
        description: "漫画IP授权、联动合作、周边开发等版权相关合作事宜。",
        email: "ip@51manhua.com",
      },
      {
        title: "广告投放",
        description: "平台广告投放、品牌联名、活动赞助等营销推广合作。",
        email: "ad@51manhua.com",
      },
      {
        title: "作者入驻",
        description: "原创漫画作者签约、作品投稿、新人培养等创作者合作。",
        email: "author@51manhua.com",
      },
    ],
  },
};